<template>
  <page-outline 
    :title="$t('Webheader.history')"
    :show-filter="true"
    :show-refresh="true"
    :show-extract="inboxMessages.length > 0"
    :filter-expanded="displayFilter"
    :refresh-disabled="activateSpinner"
    :extract-disabled="activateSpinner"
    @toggle-filter="displayFilter = !displayFilter"
    @refresh="refreshInbox"
    @extract="extractCSV">
    
    <template slot="filterContent">
      <app-panel
        :filters="filterConfig"
        :searchAriaLabel="$t('common.srch') + ' ' + $t('Webheader.history')"
        @filter-changed="onFilterChanged"
        @clear-filters="clearFilterFields"
        @apply-filters="applyFilter"
      />
    </template>
    
    <template slot="pageContent">
    <!-- <div class="layoutTop"></div> -->
      <b-container fluid class="listPage">
        <b-row>
          <b-col>
            <div class="requestsList">

              <b-row class="min-w-100">
                <b-col sm="12" lg="12" cols="12">
                  <spinner v-if="activateSpinner"></spinner>
                  <div class="w-100" v-else>
                    <!-- <span v-if="inboxMessages.length" class="font-weight-bold">{{ $t('common.results_actions_desc') + paginationObject.nbResultsTotal}}</span> -->
                    <b-table responsive hover borderless outlined class="table mt-3 text-center table-striped"
                             v-if="inboxMessages.length"
                             :items="inboxMessages"
                             :fields="historyFields"
                             :key="resetHisto">
                      <template #cell(dateAction)="data"><div class="cursor text-ellipsis"><span>{{getDate(data.value)}}</span></div></template>
                      <template #cell(name)="data">
                        <div v-if="!data.value">-</div>
                        <div v-else>{{ data.value }}</div>
                      </template>
                      <template #cell(label)="data">
                        <span v-if="!translateDetails(data.item.details, data.item).length">{{data.value}}</span>
                        <f7-accordion-item v-else class="accordionForm"
                                           :expanded="data.item.open"
                                           @accordion:open="data.item.open=true"
                                           @accordion:opened="data.item.openFinished=true;resetHisto = !resetHisto"
                                           @accordion:close="data.item.open=data.item.open=false"
                                           @accordion:closed="data.item.openFinished=false;resetHisto = !resetHisto">
                          <f7-accordion-toggle class="accordionToggle">
                            <div class="form-group row justify-content-center">
                              <div class="col-sm-auto">
                                {{ data.value }}
                                <i class="ml-1 mt-1 fa-light fa-chevron-down color-var-actionButtonColorBlue"
                                   v-if="data.item.open === true">
                                </i>
                                <i class="ml-1 fa-light fa-chevron-right color-var-actionButtonColorBlue"
                                   v-else>
                                </i>
                              </div>
                            </div>
                          </f7-accordion-toggle>
                          <f7-accordion-content :class="{accordionContentExpended: data.item.openFinished}">
                            <div v-for="(detail, index) in translateDetails(data.item.details, data.item)" :key="index">
                          <span v-if="isRTPAction(data.item)" class="cursor" @click="detailsRTP(data.item)"><u>
                            {{ $t('history.rtp_details') }}</u>
                          </span>
                              <span v-else><span><b>{{detail.name}} </b></span><span v-if="detail.old">{{detail.old}}&nbsp;<b>→</b>&nbsp;</span><span>{{detail.value}}</span></span>
                            </div>
                          </f7-accordion-content>
                        </f7-accordion-item>
                      </template>
                    </b-table>
                    <div class="d-flex justify-content-center mt-5" v-else><b>{{ $t('common.no_result')}}</b></div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="!activateSpinner" class="mt-1">
          <b-col cols="12">
            <cm-pagination :maxResultsByPage="paginationObject.maxResults" :firstIndex="paginationObject.firstIndex" :nbResultsTotal="paginationObject.nbResultsTotal" :refreshEvent="paginationObject.refresh"></cm-pagination>
          </b-col>
        </b-row>
      </b-container>
  <!-- </f7-page> -->
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment-timezone'

import MessagesFilter from '@/components/common/Filter'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import AppButton from '@/components/common/AppButton.vue'
import AppPanel from '@/components/common/AppPanel.vue'

import { downloadFileWithDefinedHeaders } from '@/helpers/download'
import { errorMessageAlert } from '@/helpers/alert'
import { formatDateTime } from '@/helpers/format'
import { loadPage } from '@/helpers/routing'

export default {
  name: 'Inbox',
  components: {
    'cm-messages-filter': MessagesFilter,
    'cm-pagination': Pagination,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'spinner': Spinner,
    'page-outline': PageOutline,
    AppButton,
    AppPanel
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    direction: {
      default: '2',
      type: String
    }
  },
  computed: {
    filterConfig() {
      return [
        {
          id: 'filter-date-begin',
          type: 'datetime',
          prop: 'dateBegin',
          labelKey: 'common.date_start_label',
          icon: 'fa-solid fa-calendar-days',
          value: this.filterValues.dateBegin,
          format: 'DD/MM/YYYY H:i:s',
          maxLength: 19,
          colSm: '6',
          colMd: '4',
          colLg: '4'
        },
        {
          id: 'filter-date-end',
          type: 'datetime',
          prop: 'dateEnd',
          labelKey: 'common.date_end_label',
          icon: 'fa-solid fa-calendar-days',
          value: this.filterValues.dateEnd,
          format: 'DD/MM/YYYY H:i:s',
          maxLength: 19,
          colSm: '6',
          colMd: '4',
          colLg: '4'
        },
        {
          id: 'filter-action-type',
          type: 'select',
          prop: 'actionType',
          labelKey: 'common.action_type',
          icon: 'fa-solid fa-list-check',
          value: this.filterValues.actionType,
          defaultOptionKey: 'history.slct_actn',
          options: this.actionOptions,
          colSm: '12',
          colMd: '4',
          colLg: '4'
        },
        {
          id: 'filter-login',
          type: 'text',
          prop: 'login',
          labelKey: 'administration.identifier',
          icon: 'fa-solid fa-user',
          value: this.filterValues.login,
          colSm: '6',
          colMd: '6',
          colLg: '6'
        },
        {
          id: 'filter-user',
          type: 'text',
          prop: 'user',
          labelKey: 'administration.user_name',
          icon: 'fa-solid fa-user-tag',
          value: this.filterValues.user,
          colSm: '6',
          colMd: '6',
          colLg: '6'
        }
      ]
    },
    actionOptions() {
      return [
        { value: '1', labelKey: 'history.action_type.1' },
        { value: '2', labelKey: 'history.action_type.2' },
        { value: '3', labelKey: 'history.action_type.3' },
        { value: '4', labelKey: 'history.action_type.4' },
        { value: '5', labelKey: 'history.action_type.5' },
        { value: '6', labelKey: 'history.action_type.6' },
        { value: '7', labelKey: 'history.action_type.7' }
      ]
    },
    actionList () {
      return {
        1: this.$i18n.t('history.action_type.1'),
        2: this.$i18n.t('history.action_type.2'),
        3: this.$i18n.t('history.action_type.3'),
        4: this.$i18n.t('history.action_type.4'),
        5: this.$i18n.t('history.action_type.5'),
        6: this.$i18n.t('history.action_type.6'),
        7: this.$i18n.t('history.action_type.7')
      }
    },
    appLanguage () {
      return this.$i18n.locale
    },
    hasAdminHistoryConsulter() {
      return this.$engine.firstOn().rights.rightIs('history_consult_admin', true)
    },
    historyFields () {
      let fields = [
        { key: 'dateAction', label: this.$t('common.date_label'), class: 'text-center col-3' },
        { key: 'login', label: this.$t('administration.identifier'), class: 'text-center col-3'},
        { key: 'name', label: this.$t('administration.user_name'), class: 'text-center col-3' },
        { key: 'label', label: this.$t('common.action_label'), class: 'text-center col-3' }
      ]
      return fields
    },
    hasInputFilter () {
      if (
        this.filterValues.dateBegin ||
        this.filterValues.dateEnd ||
        this.endToEndId ||
        this.filterValues.actionType ||
        this.filterValues.login ||
        this.filterValues.user) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      activateSpinner: false,
      completeList: [],
      currentIndex: 1,
      displayFilter: false,
      filterBy: '',
      hasDefaultFilter: false,
      inboxMessages: [],
      filterValues: {
        dateBegin: '',
        dateEnd: '',
        login: '',
        user: '',
        actionType: ''
      },
      mode: 1,
      name: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      reload: false,
      resetHisto: false,
      requestsNumber: '',
      scrollFlag: true,
      serviceId : this.$engine.firstOn().user.currentService.id.toString(),
      sortDirection: 'DESC',
      sortField: 'dateAction',
      timer: '',
      timezone: '+00:00'
    }
  },
  created () {
    this.timezone = moment.tz.guess()
    
    this.reload = false
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Historique',
      returnUrl: ''
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0

    this.mode = parseInt(this.modeFilter, 10)
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'history-page'
    this.$bus.$off('history-page')
    this.$bus.$on('history-page', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
    // this.filterTypeGet = this.filterType
    // this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.firstOn().history.cleanFilterCondition()
  },
  methods: {
    applyFilter () {
      let filterConditions = {}
      clearTimeout(this.timer)
      this.reload = true
      filterConditions.dateBegin = formatDateTime(this.filterValues.dateBegin)
      filterConditions.dateEnd = formatDateTime(this.filterValues.dateEnd)
      filterConditions.login = this.filterValues.login.trim()
      filterConditions.name = this.filterValues.user.trim()
      filterConditions.typeAction = this.filterValues.actionType
      filterConditions.lang = this.$i18n.locale.toUpperCase()

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      let that = this
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = 'DESC' //this.sortDirection

      filterConditions.maxResults = this.paginationObject.maxResults
      filterConditions.firstIndex = this.paginationObject.firstIndex

      this.activateSpinner = true
      this.$engine.firstOn().history.update(
        filterConditions
      ).then(resp => {
        let requests = []
        that.paginationObject.nbResultsTotal = 0
        that.paginationObject.nbResults = 0

        if (resp.data && resp.data.actionHistory && resp.data.actionHistory.length > 0) {
          that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
          that.paginationObject.nbResults = resp.data.actionHistory.length
          requests = resp.data.actionHistory
        }
        // requests = requests.slice(that.paginationObject.firstIndex - 1, that.paginationObject.firstIndex - 1 + that.paginationObject.maxResults)
        that.updateInbox(requests)
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    delayApplyFilter() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.applyFilter()
      }, 1500)
    },
    detailsRTP (item) {
      if (this.isJSON(item.details)) {
        let parsed = JSON.parse(item.details)
        let idRequest = parsed[0].value
        this.$engine.firstOn().services.payments.idRequest = idRequest
        this.$bus.$emit('switch-selected-menu', '/rtp/listBack/2/1/0')
        loadPage(this, {url: '/payments/transaction-details/' + idRequest})
      }
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    onFilterChanged ({ prop, value }) {
      this.filterValues[prop] = value
    },
    clearFilterFields () {
      this.filterValues.dateBegin = ''
      this.filterValues.dateEnd = ''
      this.endToEndId = ''
      this.filterValues.actionType = ''
      this.filterValues.login = ''
      this.filterValues.user = ''
      this.communicateChange()
      // this.applyFilter()
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        // this.$$('.infinite-scroll').append(
        // '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        // )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.firstOn().settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.firstOn().settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    extractCSV () {
      let firstLine = ''
      firstLine =
        this.$t('common.date_label') + ';' +
        this.$t('administration.company_name') + ';' +
        this.$t('administration.identifier') + ';' +
        this.$t('administration.user_name') + ';' +
        this.$t('common.action_label') +
        ' \r\n'

      let lines = ''
      let that = this

      // this.scrollFlag = true
      let filterConditions = {}
      //this.reload = true

      filterConditions.dateBegin = formatDateTime(this.filterValues.dateBegin)
      filterConditions.dateEnd = formatDateTime(this.filterValues.dateEnd)
      filterConditions.login = this.filterValues.login.trim()
      filterConditions.name = this.filterValues.user.trim()
      filterConditions.typeAction = this.filterValues.actionType
      filterConditions.lang = this.$i18n.locale.toUpperCase()

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = 'DESC' //this.sortDirection

      this.$engine.firstOn().history.update(
        filterConditions
      ).then(resp => {
        let historyMessagesCSV = {}
        historyMessagesCSV = resp.data.actionHistory

        for (let datas in historyMessagesCSV) {
          let actionDate = '-'
          if (historyMessagesCSV[datas].dateAction) {
            const date = historyMessagesCSV[datas].dateAction
            const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
            const isoWithTZ = hasTimezone ? date : date + 'Z';
            actionDate = moment(isoWithTZ).tz(this.timezone).format('YYYY-MM-DD HH:mm:ss')
          }
          let company = historyMessagesCSV[datas].account ? historyMessagesCSV[datas].account : '-'
          let login = historyMessagesCSV[datas].login ? historyMessagesCSV[datas].login : '-'
          let user = historyMessagesCSV[datas].name ? historyMessagesCSV[datas].name : '-'
          let action = historyMessagesCSV[datas].label ? historyMessagesCSV[datas].label : '-'

          lines += actionDate + ';' +
          company + ';' +
          login + ';' +
          user + ';' +
          action + ';' +
          '\r\n'
        }

        let data = firstLine + lines
        that.$f7.hidePreloader()
        // const linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        let encodedData = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        let linkSource = URL.createObjectURL(encodedData);
        const downloadLink = document.createElement('a')
        let today = moment()
        const fileName = that.$t('Webheader.history') + '_' + today.unix() + '.csv'
        if (
        this.$f7.device.os === 'android' ||
        this.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
        }
        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    exportList () {
      // mettre en place mode CSV coté modé
      let that = this
      let filterConditions = {}

      filterConditions.dateBegin = formatDateTime(this.filterValues.dateBegin)
      filterConditions.dateEnd = formatDateTime(this.filterValues.dateEnd)
      filterConditions.login = this.filterValues.login.trim()
      filterConditions.name = this.filterValues.user.trim()
      filterConditions.typeAction = this.filterValues.actionType

      this.$engine.firstOn().history.getExport(
        filterConditions
      ).then( resp => {
        let list = {}
        list = resp.data.ExportActionHistory
        that.updateList(list)
        that.exportHistory()
      }).catch(e => {
        errorMessageAlert(e, that)
      })
    },
    exportHistory () {
      this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
      let firstLine = 'Date' + ';' +
        'Type d\'action' + ';' +
        'Utilisateur' + ';' +
        'Identifiant' + ';' +
        'Détails' + '\r\n'

      let line = atob(this.completeList.result)
      let data = firstLine + line
      this.$f7.hidePreloader()
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      let today = moment()
      let fileName = 'history_' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    isJSON (str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    isRTPAction (item) {
      return ['2','3'].includes(item.typeAction)
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onRefresh (noAttach = false, index = 1) {
      // let that = this
      let that = this
      this.pageCounter = 0
      // this.scrollFlag = true
      this.paginationObject['firstIndex'] = index
      this.currentIndex = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions = {}

      filterConditions.dateBegin = formatDateTime(this.filterValues.dateBegin)
      filterConditions.dateEnd = formatDateTime(this.filterValues.dateEnd)
      filterConditions.login = this.filterValues.login.trim()
      filterConditions.name = this.filterValues.user.trim()
      filterConditions.typeAction = this.filterValues.actionType

      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      filterConditions.lang = this.$i18n.locale.toUpperCase()

      filterConditions.maxResults = this.paginationObject.maxResults
      filterConditions.firstIndex = this.paginationObject.firstIndex


      this.$engine.firstOn().history.update(
        filterConditions
      ).then(resp => {
        let requests = []
        that.paginationObject.nbResultsTotal = 0
        that.paginationObject.nbResults = 0

        if (resp.data && resp.data.actionHistory && resp.data.actionHistory.length > 0) {
          that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
          that.paginationObject.nbResults = resp.data.actionHistory.length
          requests = resp.data.actionHistory
        }

        that.updateInbox(requests, noAttach)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.reload = true
      this.onRefresh(false, this.paginationObject['firstIndex'])
    },
    getDate (date) {
      if (!date) return '-';

      // Si la date ne contient pas un offset explicite (+00:00, +04:00, etc.) ou 'Z', on suppose qu'elle est en UTC
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';

      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS');
    },
    translateDetails (details, item) {
      if (this.isJSON(details)) {
        let parsed = JSON.parse(details)
        if (['2','3'].includes(item.typeAction) && this.$engine.firstOn().rights.rightIs('rtp_backoffice_consult',false)) {
          return []
        }
        return parsed
      }
      return []
    },
    updateInbox (requests, noAttach = false) {
      this.inboxMessages = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    updateList (requests) {
      this.completeList = requests
    },
    showButtonImportLot () {
      // Service RTP import lot identifiant?
      return false
    }
  },
  watch:  {
    appLanguage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.onRefresh(false, this.currentIndex)
      }
    }
  }
}
</script>
